import { Component } from 'react'
import * as cn from 'classnames'
import StickyHeader from 'components/unorganized/StickyHeader'
import ExternalHeader from 'components/features/external/ExternalHeader/ExternalHeader'
import * as styles from 'components/features/external/ExternalStickyHeader/ExternalStickyHeader.styl'
import { HeaderTheme } from 'interfaces/component'

export type ExternalStickyHeaderStateProps = {
  headerOffset: number
}

export type ExternalStickyHeaderOwnProps = {
  theme: HeaderTheme
  withBorder?: boolean
}

type ExternalStickyHeaderProps =
  & ExternalStickyHeaderOwnProps
  & ExternalStickyHeaderStateProps

class ExternalStickyHeader extends Component<ExternalStickyHeaderProps> {
  render () {
    const className = cn(styles.externalStickyHeader, {
      [styles.light]: this.props.theme === 'light',
      [styles.withBorder]: this.props.withBorder,
    })
    return (
      <StickyHeader
        isScrolled={ this.isScrolled }
        className={ className }
      >
        <ExternalHeader theme={ this.props.theme } hasLoginButton hasJoinButton isSticky />
      </StickyHeader>
    )
  }

  private isScrolled = () =>
    window.pageYOffset > this.props.headerOffset
}

export default ExternalStickyHeader
